import React from 'react';
import { movdTokens } from '../design-system/movdTokens.js';

const stages = ['Build', 'Details', 'Movers', 'Booking', 'Confirm'];

export default function ProgressStepper({ currentStep = 0 }) {
  return (
    <nav aria-label="Move journey" style={{ display: 'grid', gridTemplateColumns: `repeat(${stages.length}, minmax(0, 1fr))`, gap: 8, maxWidth: 760, margin: '0 auto' }}>
      {stages.map((stage, index) => {
        const active = index === currentStep;
        const complete = index < currentStep;
        return <div key={stage} style={{ minWidth: 0 }}>
          <div style={{ height: 4, background: complete || active ? movdTokens.color.teal : movdTokens.color.paperMuted, transition: `background ${movdTokens.motion.standard}` }} />
          <div style={{ marginTop: 8, color: active ? movdTokens.color.ink : complete ? '#176B60' : '#7A8B86', fontSize: 10, fontWeight: active ? 900 : 750, letterSpacing: '.12em', overflow: 'hidden', textOverflow: 'ellipsis', textTransform: 'uppercase', whiteSpace: 'nowrap' }}>{stage}</div>
        </div>;
      })}
    </nav>
  );
}
